import { ComponentType, createContext, Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { useKlskDhp } from "@hilma/auth";
import { useAlert } from "@hilma/netina2all";
import axios from "axios";

import { STATION_MANAGEMENT_COMPONENT_NAME } from "../constants";
import { StationStatus } from "../types";
import { useI18n } from "../hooks";
interface StationStatusProviderValue {
    isOpenOrClose: boolean;
    status: StationStatus | null;
    setStatus: Dispatch<SetStateAction<StationStatus | null>>;
}

export const StationStatusContext = createContext<StationStatusProviderValue | null>(null)

interface ChildrenProps {
    children: React.ReactNode;
}

export const StationStatusProvider: ComponentType<ChildrenProps> = ({ children }) => {
    const [status, setStatus] = useState<StationStatus | null>(null);

    const isOpenOrClose = useMemo(() => status === StationStatus.Open || status === StationStatus.Close, [status]);

    const { klsk } = useKlskDhp();

    const alert = useAlert();
    const errText = useI18n(i18n => i18n.errText.generalShort);

    const getStatus = useCallback(async () => {
        try {
            if (!klsk.includes(STATION_MANAGEMENT_COMPONENT_NAME)) return; //user is not station_manager so station status doesn't need to be fetched

            const { data } = await axios.get<StationStatus>('/api/station/station-status');
            setStatus(data);
        } catch (err) {
            console.error('err: ', err);
            alert(errText);
        }
    }, [klsk])

    useEffect(() => {
        getStatus()
    }, [])

    return (
        <StationStatusContext.Provider value={{ status, setStatus, isOpenOrClose }}>
            {children}
        </StationStatusContext.Provider>
    )
}